// import logo from "../assets/images/remove-logo.png";
// import { Link } from "react-router-dom";

function Header() {
  return (
    <header>
      {/* <Link to="/" onClick={() => window.location.reload()}>
        <img src={logo} alt="Remove"></img>
      </Link> */}
    </header>
  );
}

export default Header;
